module.exports = __webpack_public_path__ + "static/media/ully-launcher.8ed54702.png";